import { Typography as MuiTypography, makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { pascalCase } from 'pascal-case'
import PropTypes from 'prop-types'

const extendedColors = [
  'lightPurple',
  'purple',
  'orange',
  'yellow',
  'darkGreen',
  'lightGreen',
]

const useStyles = makeStyles(theme => ({
  ...extendedColors.reduce((colorStyles, colorName) => {
    colorStyles[`color${pascalCase(colorName)}`] = {
      color: theme.palette[colorName].main,
    }
    return colorStyles
  }, {}),
}))

const Typography = ({ className, color, ...props }) => {
  const classes = useStyles()
  const extendedColor = extendedColors.includes(color)

  const classNames = clsx(
    extendedColor && classes[`color${pascalCase(color)}`],
    className
  )

  return (
    <MuiTypography
      className={classNames}
      color={extendedColor ? undefined : color}
      {...props}
    />
  )
}

Typography.propTypes = {
  color: PropTypes.oneOf([
    'initial',
    'inherit',
    'primary',
    'secondary',
    'textPrimary',
    'textSecondary',
    'error',
    ...extendedColors,
  ]),
}

export default Typography
